import { motion } from "framer-motion";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

interface Badge {
  id: string;
  name: string;
  icon: string;
  description: string;
}

interface BadgeDisplayProps {
  badges: Badge[];
  maxDisplay?: number;
}

export const BadgeDisplay = ({ badges, maxDisplay = 5 }: BadgeDisplayProps) => {
  const displayBadges = badges.slice(0, maxDisplay);
  const remaining = badges.length - maxDisplay;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {displayBadges.map((badge, index) => (
        <Tooltip key={badge.id}>
          <TooltipTrigger>
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ delay: index * 0.1, type: "spring" }}
              className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-success/20 border-2 border-primary/30 shadow-md hover:scale-110 transition-transform"
            >
              <span className="text-xl">{badge.icon}</span>
            </motion.div>
          </TooltipTrigger>
          <TooltipContent>
            <div className="text-center">
              <p className="font-semibold">{badge.name}</p>
              <p className="text-xs text-muted-foreground">{badge.description}</p>
            </div>
          </TooltipContent>
        </Tooltip>
      ))}
      
      {remaining > 0 && (
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-muted text-muted-foreground text-sm font-semibold">
          +{remaining}
        </div>
      )}
    </div>
  );
};